import { Button } from 'antd';

interface MetricCodeButtonProps {
  onClick: () => void;
}

export default function MetricCodeButton({ onClick }: MetricCodeButtonProps) {
  const iconStyle = {
    width: 16,
    height: 16,
    position: 'absolute' as const,
    right: '-6px',
    top: '3px',
  };

  return (
    <Button
      type="link"
      onClick={onClick}
      style={{
        padding: '4px 8px',
        height: 'auto',
        fontSize: '14px',
        color: '#105FC8'
      }}
      icon={
        <div style={{ position: 'relative', display: 'inline-block', width: 16, height: 16 }}>
          <img
            src="/assets/icons/common/code-list.png"
            alt="code-list"
            style={iconStyle}
          />
        </div>
      }
    >
      《经营指标代码以及编码规则2025年版》
    </Button>
  );
}